import { render } from "./IndividualsForOwner.vue?vue&type=template&id=0bbdc65c&scoped=true"
import script from "./IndividualsForOwner.vue?vue&type=script&lang=js"
export * from "./IndividualsForOwner.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&id=0bbdc65c&scoped=true&lang=css"
import "./IndividualsForOwner.vue?vue&type=style&index=1&id=0bbdc65c&scoped=true&lang=css"
import "./IndividualsForOwner.vue?vue&type=style&index=2&id=0bbdc65c&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbdc65c"]])

export default __exports__